import bem from '../../../../utils/bem';
import Icon from '../../../Atoms/Icon/Icon';
import Tip from '../../../Atoms/tip';

const ProcessCard = ({ title, tooltip, completed, className, children }) => {
  const componentClasses = bem('process-card', [completed && 'completed'], '', [
    className,
  ]);
  return (
    <div className={componentClasses}>
      {tooltip && (
        <div className="process-card__tooltip">
          <Tip content={tooltip} allowHTML interactive />
        </div>
      )}

      {title && (
        <div className="process-card__heading">
          <p className="process-card__title">{title}</p>
          <span aria-hidden="true" className="process-card__status-icon">
            <Icon iconName="checked" />
          </span>
        </div>
      )}

      {children}
    </div>
  );
};

export default ProcessCard;
